import Lotes from "./Lotes";
import { withRouter } from "react-router-dom";

export default withRouter(Lotes);
